/**
 * ——封装清单列表展示信息的工具类
 * ——应用：清单界面 四象限 列表展示时调用；
 */

import initData from "../initData";
import store from "../../store";
import utils from "../../utils";

const workDate = initData.workDays;
const restDate = initData.restDays;

export default {
    todayDate: Solar.fromDate(new Date()).toYmd(),
    info: {
        inventoryId: "",
        title: "",
        priority: 4,
        iconIsRemind: false,
        iconIsRepeat: false,
        iconIsTop: false,
        isWaiting: false,
        startTime: -1,
    },
    timeInfo: {
        state: 0,
        dateText: "",
        timeText: "",
        clockTargetDate: "",
    },
    lineInfo: {
        startDate: "",
        dataTape: 0,
    },
    childArray: [],
    setWaitMatters: function(){
        const categoryShowId = store.state.listModules.categoryShowId;
        const matterArray = [];
        store.state.listModules.tbListInfo.forEach((matter)=>{
            // 判断 未开始
            if(matter.startDate !== ""){
                // 待办
                return
            }else if(categoryShowId !== "all" && categoryShowId !== matter.categoryId){
                return
            }
            // 初始化
            this.initItemInfo(JSON.parse(JSON.stringify(matter)));

            this.checkClock("");
            matterArray.push({
                info: this.info,
                timeInfo: this.timeInfo,
                lineInfo: this.lineInfo,
                childArray: this.childArray,
            })
        })
        return matterArray
    },
    setMonthDays: function(dayItems){
        const categoryShowId = store.state.listModules.categoryShowId;

        const matters = store.state.listModules.tbListInfo.filter((item)=>{
            return item.startDate !== "" && (categoryShowId === "all" || categoryShowId === item.categoryId)
        })
        dayItems.forEach((dayItem)=>{
            dayItem.matterArray = [];
            this.getListItems(dayItem, matters);
            dayItem.matterArray.sort((nextItem, item)=>{
                if(nextItem.timeInfo.state === item.timeInfo.state){
                    if(nextItem.info.crossDays === item.info.crossDays && nextItem.crossDays === 0){

                        return item.info.startTime - nextItem.info.startTime
                    }else{
                        return item.info.crossDays - nextItem.info.crossDays
                    }
                }else{
                    return nextItem.timeInfo.state - item.timeInfo.state
                }
            })
        })
    },

    /**
     * @param dayItem 目标日期
     * @param matters 清单
     */
    getListItems: function(dayItem, matters){
        const targetDate = dayItem.date;
        matters.forEach((matter)=>{

            // 判断 未开始
            if(matter.startDate > targetDate){
                // 未开始
                return
            }else if(matter.endDate !== "" && matter.endDate < targetDate){
                // 已结束
                return
            }else if(matter.crossEndDate !== "" && matter.crossEndDate < targetDate){
                // 跨天结束
                return
            }else if(matter.repeatDeleteDates.search(targetDate) > -1){
                // 删除日期
                return
            }else if(matter.skipHolidaysState && restDate.search(targetDate) > -1){
                // 跳过节假日
                return
            }
            // 初始化
            this.initItemInfo(JSON.parse(JSON.stringify(matter)));
            // 重复
            if (!this.checkRepeatInDay(targetDate)){
                return
            }
            // 时间线
            if(matter.hasRepeatBranch){
                this.setLineInfo(matter.startDate, targetDate);
            }

            // 打卡日期
            let clockDate = targetDate;

            if(this.crossDays > 0){
                clockDate = this.startDate;
            }

            this.checkClock(clockDate);
            const childArray = this.getChildArray(clockDate);
            dayItem.matterArray.push({
                info: this.info,
                timeInfo: this.timeInfo,
                lineInfo: this.lineInfo,
                childArray: childArray
            })
        })
    },
    /**
     * 初始化信息
     */
    initItemInfo: function(matter){
        this.info = {
            inventoryId: matter.inventoryId,
            title: matter.title,
            priority: matter.priorityLevel,
            iconIsRemind: matter.remindTimes !== "",
            iconIsRepeat: matter.repeatType !== "",
            iconIsTop: matter.topState,
            isWaiting: matter.startDate === "",
            categoryId: matter.categoryId,
            categoryTitle: matter.categoryTitle,
            crossDays: 0,

            startDate: matter.startDate,
            crossEndDate: matter.crossEndDate,
            startTime: matter.startTime,
            endTime: matter.endTime,
            color: "",
        }
        this.info.color = "#" + (matter.color.toString(16).slice(2)).toUpperCase();
        this.timeInfo = {
            state: 0,
            dateText: "",
            timeText: "",
            clockTargetDate: "",
        }
        this.lineInfo = {
            startDate: "",
            dataTape: 0,
        }

        // 跨天信息
        this.repeatType = matter.repeatType;
        this.repeatCycle = matter.repeatCycle;
        this.repeatInfo = matter.repeatInfo;
        this.startDate = matter.startDate;
        this.crossEndDate = matter.crossEndDate;
        this.startTime = matter.startTime;
        this.endTime = matter.endTime;

        if(matter.crossEndDate === ""){
            this.crossDays = 0
        }else{
            this.crossDays = utils.getIntervalDays(matter.crossEndDate, matter.startDate);
        }
        this.info.crossDays = this.crossDays;

    },

    setLineInfo: function(startDate, targetDate){
        const lineArray = store.state.listModules.tbListLine.filter((item)=>{
            return item.linkInventoryId === this.info.inventoryId && item.startDate >= startDate
        })
        lineArray.sort((nextItem, item)=>{
            let nextItemKey, itemKey;
            nextItemKey = parseInt(nextItem.startDate.replaceAll("-", ""));
            itemKey = parseInt(item.startDate.replaceAll("-", ""));
            if(nextItemKey === itemKey){
                return item.dataType - nextItem.dataType
            }else{
                return nextItemKey - itemKey
            }
        })
        let lineItem;

        for (let i=0, l=lineArray.length; i<l; i++){
            const tempLine = lineArray[i];
            if(tempLine.dataType === 1 && targetDate === tempLine.startDate){
                lineItem = tempLine;
                break
            }else if(tempLine.dataType === 0 && targetDate >= tempLine.startDate){
                lineItem = tempLine;
                break
            }
        }
        if (lineItem){
            this.lineInfo.startDate = lineItem.startDate;
            this.lineInfo.dataTape = lineItem.dataTape;
            this.info.title = lineItem.title;
        }
    },
    getChildArray: function(clockDate){
        let childArray = [];

        store.state.listModules.tbListChild.forEach((item)=>{
            if(item.linkInventoryId === this.info.inventoryId){
                const childInfo = {
                    childId: item.childId,
                    title: item.title,
                    sortNum: item.sortNum,
                }
                const timeInfo = this.checkChildClock(clockDate, item.childId);
                childArray.push({
                    info: childInfo,
                    timeInfo: timeInfo,
                })
            }
        })
        childArray.sort((nextItem, item)=>{
            if(nextItem.timeInfo.state === item.timeInfo.state){
                if(nextItem.timeInfo.state === 0){
                    return item.info.sortNum - nextItem.info.sortNum
                }else{
                    return nextItem.timeInfo.clockTimeStamp - item.timeInfo.clockTimeStamp
                }
            }else{
                return nextItem.timeInfo.state - item.timeInfo.state
            }

        })
        return childArray
    },
    checkChildClock: function(clockDate, childId){
        const clockArray = store.state.listModules.tbListClock.filter((item)=>{
            return item.linkDataId === childId && item.clockDate === clockDate
        })
        let timeInfo = {
            state: 0,
            dateText: "",
            clockTimeStamp: 0,
        }

        if(clockArray.length > 0){
            // 未打卡
            const clockItem = clockArray[0];
            if(clockItem.clockState >= 1){
                // 已打卡
                const dateTime = new Date(clockItem.clockTimeStamp);
                const dateArray = dateTime.toLocaleDateString().split("/");

                let dateText = dateArray[1] +"月" + dateArray[2] +"日 " + dateTime.toLocaleTimeString().slice(0,5);
                if(this.todayDate.slice(0, 4) !== dateArray[0]){
                    dateText = dateArray[0] + "年" + dateText
                }

                timeInfo.state = clockItem.clockState;
                timeInfo.dateText = dateText;
                timeInfo.clockTimeStamp = clockItem.clockTimeStamp;
            }
        }
        return timeInfo
    },
    /**
     * 校验当天存在事件
     * @param targetDate
     * @returns {boolean}
     */
    checkRepeatInDay: function(targetDate){
        let isInDay = false;
        if(this.repeatType === "" && targetDate === this.startDate){
            isInDay = true
        }else if(this.crossDays > 0){
            isInDay = true
        }if(this.repeatType === "every_day"){
            isInDay = true
        }else if(this.repeatType === "every_week"){
            isInDay = this.checkEveryWeek(targetDate)
        }else if(this.repeatType === "work_day"){
            isInDay = this.checkWorkDay(targetDate)
        }else if(this.repeatType === "every_month"){
            isInDay = this.checkEveryMonth(targetDate)
        }else if(this.repeatType === "every_year"){
            isInDay = this.checkEveryYear(targetDate)
        }else if(this.repeatType === "month_week"){
            isInDay = this.checkMonthWeek(targetDate)
        }else if(this.repeatType === "lunar_year"){
            isInDay = this.checkLunarYear(targetDate)
        }else if(this.repeatType === "i_b_h_s"){
            isInDay = this.checkIBHS(targetDate)
        }else if(this.repeatType === "custom_date"){
            isInDay = this.repeatInfo.search(targetDate) >= 0;
        }else if(this.repeatType === "custom_day"){
            isInDay = this.checkCustomDay(targetDate);
        }else if(this.repeatType === "custom_week"){
            isInDay = this.checkCustomWeek(targetDate)
        }else if(this.repeatType === "custom_month"){
            isInDay = this.checkCustomMonth(targetDate)
        }else if(this.repeatType === "custom_year"){
            isInDay = this.checkCustomYear(targetDate)
        }
        return isInDay
    },
    // 重复每周
    checkEveryWeek: function(targetDate) {
        let week = Solar.fromDate(new Date(targetDate)).getWeek();
        if(week === 0){
            week = 7
        }
        return this.repeatInfo.search(week) !== -1;
    },
    // 重复法定工作日
    checkWorkDay: function(targetDate) {
        const itemDay = Solar.fromDate(new Date(targetDate));
        let week = itemDay.getWeek();
        const itemYmd = itemDay.toYmd();
        if(week === 0){
            week = 7
        }
        return (week >= 6 && workDate.search(itemYmd) !== -1) || (week <= 5 && restDate.search(itemYmd) === -1);
    },
    checkEveryMonth: function(targetDate) {
        const itemDay = Solar.fromDate(new Date(targetDate));
        return itemDay.getDay() === parseInt(this.repeatInfo);
    },
    checkEveryYear: function(targetDate) {
        const itemDay = Solar.fromDate(new Date(targetDate));
        const repeatInfo = utils.splitRepeatInfo(this.repeatInfo, "date");

        return itemDay.getMonth() === repeatInfo.month && itemDay.getDay() === repeatInfo.day
    },

    checkMonthWeek: function(targetDate){
        const itemDay = Solar.fromDate(new Date(targetDate));
        let week = itemDay.getWeek();
        if (week === 0){
            week = 7
        }
        const weekItem = SolarWeek.fromDate(new Date(targetDate), 1);
        const repeatInfo = utils.splitRepeatInfo(this.repeatInfo, "week");

        return weekItem.getIndex() === repeatInfo.weekIndex && repeatInfo.week === week;
    },
    checkLunarYear: function(targetDate){
        const lunarDay = Lunar.fromDate(new Date(targetDate));
        const repeatInfo = utils.splitRepeatInfo(this.repeatInfo, "date");
        return lunarDay.getMonth() === repeatInfo.month && lunarDay.getDay() === repeatInfo.day;
    },
    checkIBHS: function(targetDate) {
        const dayNum = utils.getIntervalDays(targetDate, this.startDate);
        if (dayNum >= 15 && dayNum % 15 === 0){
            return true
        }else {
            return dayNum < 15 && [0, 1, 2, 4, 7].indexOf(dayNum) !== -1
        }
    },
    checkCustomDay: function(targetDate){
        const dayNum = utils.getIntervalDays(targetDate, this.startDate);
        return dayNum % this.repeatCycle === 0;
    },

    checkCustomWeek: function(targetDate) {
        let week = Solar.fromDate(new Date(targetDate)).getWeek();
        if(week===0){
            week = 7
        }
        return this.repeatInfo.search(week) !== -1;
    },
    checkCustomMonth: function(targetDate) {
        const itemDay = Solar.fromDate(new Date(targetDate));

        const targetDays = this.repeatInfo.split(",");
        if(targetDays.indexOf(itemDay.getDay()) >= 0){
            return true
        }else if(targetDays.indexOf(99) >= 0){
            // 最后一天
            const days = SolarMonth.fromYm(itemDay.getYear(), itemDay.getMonth()).getDays();
            return itemDay.getDay() === days.length;
        }else{
            return false
        }
    },
    checkCustomYear: function(targetDate) {
        const itemDay = Solar.fromDate(new Date(targetDate));
        const repeatInfo = utils.splitRepeatInfo(this.repeatInfo, "date");
        return itemDay.getMonth() === repeatInfo.month && itemDay.getDay() === repeatInfo.day;
    },
    checkClock: function(clockDate){
        const clockArray = store.state.listModules.tbListClock.filter((item)=>{
            return item.linkDataId === this.info.inventoryId && item.clockDate === clockDate;
        })
        if(clockArray.length === 0){
            // 未打卡
            this.setNotClockInfo(clockDate);
        }else{
            const clockItem = clockArray[0];
            if(clockItem.clockState === 0){
                // 未打卡
                this.setNotClockInfo(clockDate);
            }else{
                // 已打卡
                this.setClockInfo(clockItem);
            }
        }
    },
    setNotClockInfo: function(clockDate){
        let day_num = 0;
        let dateText = "";
        let timeText = "";
        let state = 0;

        if(clockDate === ""){
            this.timeInfo.state = state;
            this.timeInfo.dateText = dateText;
            this.timeInfo.timeText = timeText;
            this.timeInfo.clockTargetDate = clockDate;
            return
        }

        if(this.crossDays > 0){
            // 跨天
            day_num = utils.getIntervalDays(this.crossEndDate, this.todayDate);
        }else{
            day_num = utils.getIntervalDays(clockDate, this.todayDate);
        }

        if(day_num >= 0 && this.crossDays > 0){

            const startDate = this.startDate.split("-");
            const crossEndDate = this.crossEndDate.split("-");

            if(startDate[0] === crossEndDate[0]){
                dateText = dateText.concat(
                    parseInt(startDate[1]), "月", parseInt(startDate[2]),"日", "-",
                    parseInt(crossEndDate[1]), "月", parseInt(crossEndDate[2]),"日");
            }else{
                dateText = dateText.concat(
                    startDate[0], "年", parseInt(startDate[1]), "月", parseInt(startDate[2]),"日", "-",
                    crossEndDate[0], "年", parseInt(crossEndDate[1]), "月", parseInt(crossEndDate[2]), "日");
            }

        }else if(day_num > 0){
            // N 天后
            dateText = day_num + "天后";
        }else if(day_num === 0){
            // 当天
            dateText = "今天";
        }else{
            // 逾期
            dateText = "逾期" + Math.abs(day_num) + "天";
            state = -1
        }

        if(this.startTime === -1 || this.crossDays > 0){
            // 全天 或者 跨天
            timeText = ""
        }else if(this.endTime === -1){
            // 时间点
            const startTime = utils.minuteToTime(this.startTime);
            timeText = startTime.hour + ":" + startTime.minute;
        }else{
            // 时间段
            const startTime = utils.minuteToTime(this.startTime);
            const endTime = utils.minuteToTime(this.endTime);

            timeText = startTime.hour + ":" + startTime.minute + "-" + endTime.hour + ":" + endTime.minute;
        }
        this.timeInfo.state = state;
        this.timeInfo.dateText = dateText;
        this.timeInfo.timeText = timeText;
        this.timeInfo.clockTargetDate = clockDate;

    },
    setClockInfo: function(clockItem){
        const dateTime = new Date(clockItem.clockTimeStamp);
        const dateArray = dateTime.toLocaleDateString().split("/");
        let dateText = dateArray[1] +"月" + dateArray[2] +"日 " + dateTime.toLocaleTimeString().slice(0, 5);
        if(this.todayDate.slice(0, 4) !== dateArray[0]){
            dateText = dateArray[0] + "年" + dateText
        }

        this.timeInfo.state = clockItem.clockState;
        this.timeInfo.dateText = dateText;
        this.timeInfo.timeText = "";
        this.timeInfo.clockTargetDate = clockItem.clockDate;
    },
}